import { supabase } from '../supabase/client';

export const getCurrentDestination = async () => {
  // For now, just get the first destination
  const { data, error } = await supabase.from('cities').select('*').limit(1);

  if (error) {
    throw error;
  }

  // Return the first city or null if none exist
  return data?.[0] || null;
};
